import React, { useState } from 'react';

const SUPABASE_URL = 'https://rgmjpifqmnglgdcwrkpc.supabase.co';
const SUPABASE_ANON_KEY = 'sb_publishable_3tO_FspP7eacQGDSuuZlog_OfXfDRFC';

function Upgrade({ orgId, orgName, onBack, onUpgradeSuccess }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleUpgrade = async () => {
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${SUPABASE_URL}/functions/v1/create-checkout-session`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
        },
        body: JSON.stringify({ orgId }),
      });

      const data = await response.json();

      if (data.error) {
        setError(data.error);
        setLoading(false);
        return;
      }

      window.location.href = data.url;
    } catch (err) {
      setError('Something went wrong. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="top-bar">
        <button className="btn btn-gray" onClick={onBack}>← Back</button>
      </div>

      <div className="header">
        <h2>⭐ Upgrade to Pro</h2>
        <p>Unlock the full power of SafeRoster</p>
      </div>

      {/* Current Plan */}
      <div style={currentPlanStyle}>
        <p style={{ margin: 0, fontSize: '14px', color: '#888' }}>Current Plan</p>
        <p style={{ margin: '4px 0 0', fontSize: '18px', fontWeight: '700', color: '#1a1a2e' }}>
          Free Plan — {orgName}
        </p>
      </div>

      {/* Pro Plan Card */}
      <div style={proPlanStyle}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
              <span style={{ fontSize: '20px' }}>⭐</span>
              <h3 style={{ margin: 0, fontSize: '22px', fontWeight: '900', color: '#1a1a2e' }}>Pro Plan</h3>
            </div>
            <p style={{ margin: 0, color: '#888', fontSize: '14px' }}>Everything you need to run safely</p>
          </div>
          <div style={{ textAlign: 'right' }}>
            <p style={{ margin: 0, fontSize: '32px', fontWeight: '900', color: '#1a56db' }}>$29</p>
            <p style={{ margin: 0, fontSize: '13px', color: '#888' }}>per month</p>
          </div>
        </div>

        <div style={featuresListStyle}>
          {[
            '✅ Unlimited daily check-ins',
            '✅ QR code check-in',
            '✅ PIN verified pickup',
            '✅ Real-time staff dashboard',
            '✅ Attendance reports',
            '✅ CSV export',
            '✅ Multiple organizations',
            '✅ Classroom view',
            '✅ Priority support',
          ].map((feature, i) => (
            <p key={i} style={{ margin: '0 0 10px', fontSize: '15px', color: '#444' }}>{feature}</p>
          ))}
        </div>

        <button
          className="btn btn-primary"
          onClick={handleUpgrade}
          disabled={loading}
          style={{ marginTop: '8px' }}
        >
          {loading ? 'Redirecting to Checkout...' : 'Upgrade to Pro — $29/mo →'}
        </button>

        <p style={{ textAlign: 'center', color: '#888', fontSize: '13px', marginTop: '12px' }}>
          Secure payment powered by Stripe. Cancel anytime.
        </p>
      </div>

      {/* Free Plan Reminder */}
      <div style={freePlanStyle}>
        <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>
          <strong>Free Plan includes:</strong> 15 daily check-ins, QR code check-in, PIN pickup, staff dashboard
        </p>
      </div>

      {error && <div className="error-message">{error}</div>}
    </div>
  );
}

const currentPlanStyle = {
  background: '#f8faff',
  border: '2px solid #e8f0fe',
  borderRadius: '16px',
  padding: '16px 20px',
  marginBottom: '16px',
};

const proPlanStyle = {
  background: 'white',
  border: '3px solid #1a56db',
  borderRadius: '20px',
  padding: '28px 24px',
  marginBottom: '16px',
  boxShadow: '0 8px 32px rgba(26,86,219,0.15)',
};

const featuresListStyle = {
  background: '#f8faff',
  borderRadius: '12px',
  padding: '16px 20px',
  marginBottom: '16px',
};

const freePlanStyle = {
  background: '#f8faff',
  border: '2px solid #e8f0fe',
  borderRadius: '16px',
  padding: '16px 20px',
};

export default Upgrade;